var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalmentPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27139",
    "data-name": "Group 27139",
    transform: "translate(-42 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_38206",
    "data-name": "Path 38206",
    transform: "translate(42 508)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14 2 C 10.79467964172363 2 7.781219482421875 3.248220443725586 5.514720916748047 5.514720916748047 C 3.248220443725586 7.781219482421875 2 10.79467964172363 2 14 C 2 17.2053108215332 3.248220443725586 20.21878051757812 5.514720916748047 22.48527908325195 C 7.781219482421875 24.75177955627441 10.79467964172363 26 14 26 C 17.2053108215332 26 20.21878051757812 24.75177955627441 22.48527908325195 22.48527908325195 C 24.75177955627441 20.21878051757812 26 17.2053108215332 26 14 C 26 10.79467964172363 24.75177955627441 7.781219482421875 22.48527908325195 5.514720916748047 C 20.21878051757812 3.248220443725586 17.2053108215332 2 14 2 M 14 0 C 21.73197937011719 0 28 6.268009185791016 28 14 C 28 21.73197937011719 21.73197937011719 28 14 28 C 6.268009185791016 28 0 21.73197937011719 0 14 C 0 6.268009185791016 6.268009185791016 0 14 0 Z",
    stroke: "none",
    fill: "#13cc93"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37792",
    "data-name": "Path 37792",
    d: "M1956.791,932.737l3.843,3.733,8.726-8.967",
    transform: "translate(-1906.664 -410.227)",
    fill: "none",
    stroke: "#13cc93",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalmentPaid);
export default __webpack_public_path__ + "static/media/instalment-paid.41f4caebef7adc436ef37f070452cfd7.svg";
export { ForwardRef as ReactComponent };